import { useEffect, useState } from "react"

const DEFAULT_SCROLL_THRESHOLD = 20

export const useHeaderScrollState = (threshold = DEFAULT_SCROLL_THRESHOLD) => {
  const [isScrolled, setIsScrolled] = useState(() => window.scrollY > threshold)

  useEffect(() => {
    let animationFrame: number | null = null

    const updateState = () => {
      setIsScrolled(window.scrollY > threshold)
      animationFrame = null
    }

    const handleScroll = () => {
      if (animationFrame === null) {
        animationFrame = window.requestAnimationFrame(updateState)
      }
    }

    updateState()
    window.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      window.removeEventListener("scroll", handleScroll)
      if (animationFrame !== null) window.cancelAnimationFrame(animationFrame)
    }
  }, [threshold])

  return isScrolled
}

